import React, { useEffect } from 'react';
import { useState } from 'react';
import { toast } from 'react-toastify';
import { getContract, getNFTContract, getWalletNFTDetails } from '../hooks/contractHelper';
import daoAbi from '../json/daoAbi.json';
import daorewardAbi from '../json/daoreward.json';
import daorewardethAbi from '../json//daorewardeth.json';
import { contract, DAO_REWARD, DAO_SUPPOTED_CHAIN, DEFAULT_CHAIN } from '../hooks/constant';
import { getWeb3 } from '../hooks/connectors';
import { useEthersSigner } from '../hooks/useEthersProvider';
import { useAccount, useNetwork } from 'wagmi';
import { ethers } from 'ethers';
import { useDaoEthState } from '../hooks/useDaoEth';
import { MulticallContractWeb3 } from '../hooks/useContracts';
import Header from '../components/Header';
import Sidebar from '../components/Sidebar';
import { useHistory } from 'react-router-dom';
import Footer from '../components/Footer';




export default function AdminSetup() {
    const { address: account } = useAccount();
    const { chain } = useNetwork()
    const library = useEthersSigner();
    const [nftAddress, setNftAddress] = useState('');
    const [nfttokenAddress, setNfttokenAddress] = useState('');
    const [tokenId, setTokenId] = useState('');
    const [tokenAddress, setTokenAddress] = useState('');
    const [enableVote, setEnableVote] = useState('');
    const [inputFields, setInputFields] = useState([{
        service: 'Yes',
    }]);
    const [daoreward, setDaoReward] = useState('');
    const [updater, setUpdater] = useState(1)
    const daoEthState = useDaoEthState(updater);
    const [ethDetails, setEthDetails] = useState({
        totalSupply: '',
        weightPercentage: '',
        daoreward: '',
        nftid: 0,
        nftbalance: ''
    })
    const history = useHistory();


    useEffect(() => {
        let isLogin = localStorage.getItem("blockstardao");
        if (isLogin === null || isLogin === 'null') {
            history.push('/')
        }

    }, []);


    useEffect(() => {
        setEthDetails({
            ...ethDetails,
            totalSupply: daoEthState.getTotalSupply.join(','),
            weightPercentage: daoEthState.getWeightPercentage.map((items) => items / 100).join(','),
        })
    }, [daoEthState])

    const addInputField = () => {

        setInputFields([...inputFields, {
            service: '',
        }])
    }

    const removeInputFields = (index, e) => {
        e.preventDefault();
        const rows = [...inputFields];
        rows.splice(index, 1);
        setInputFields(rows);
    }

    const handleChange = (index, evnt) => {
        const { name, value } = evnt.target;
        const list = [...inputFields];
        list[index][name] = value;
        setInputFields(list);
    }

    const handleEthChange = (e) => {
        setEthDetails({
            ...ethDetails,
            [e.target.name]: e.target.value
        });
    };


    const handleAdminSubmit = async (id) => {
        try {
            if (account) {
                if (chain && chain.id && parseInt(chain.id) === parseInt(DEFAULT_CHAIN)) {
                    let daoContract = getContract(daoAbi, contract[DEFAULT_CHAIN].DAO_ADDRESS, library);
                    let daoRewardContract = getContract(daorewardAbi, DAO_REWARD[DEFAULT_CHAIN].DAO_REWARD_ADDRESS, library);
                    let tx;
                    if (id === 1) {
                        if (enableVote === '') {
                            toast.error('Please enter valid input value!!');
                            return;
                        }
                        tx = await daoContract.disableVoting(enableVote, { 'from': account });
                    }
                    else if (id === 2) {
                        const rows = [...inputFields];
                        let voteOption = [];
                        rows.map((product) => {
                            if (product.service !== '') {
                                voteOption.push(product.service);
                            }
                            return true;
                        })
                        if (voteOption.length <= 0) {
                            toast.error('Please enter valid input value!!');
                            return;
                        }
                        tx = await daoContract.setVotingWeight(voteOption, { 'from': account });
                    }
                    else if (id === 5) {
                        if (nftAddress === '') {
                            toast.error('Please enter valid input value!!');
                            return;
                        }
                        tx = await daoContract.setNft(nftAddress, { 'from': account });
                    }
                    else if (id === 6) {
                        if (nfttokenAddress === '' || tokenId === '') {
                            toast.error('Please enter valid input value!!');
                            return;
                        }
                        tx = await daoContract.rescueNft1155(nfttokenAddress, tokenId, { 'from': account });
                    }
                    else if (id === 7) {
                        if (tokenAddress === '') {
                            toast.error('Please enter valid input value!!');
                            return;
                        }
                        tx = await daoContract.rescueToken(tokenAddress, { 'from': account });
                    }
                    else if (id === 8) {
                        tx = await daoContract.rescueFunds({ 'from': account });
                    }
                    else if (id === 9) {
                        // Split the input data into lines
                        const lines = daoreward.trim().split('\n');

                        // Initialize arrays for addresses, balances, and decimals
                        const addresses = [];
                        const balances = [];
                        const decimals = [];

                        // Process each line
                        lines.forEach(line => {
                            const [address, decimal, balance] = line.split(','); // Split each line by commas
                            addresses.push(address.trim());                      // Push address
                            balances.push(balance.trim());                       // Push balance as string
                            decimals.push(decimal ? parseInt(decimal.trim()) : 18); // Default decimal to 18 if undefined
                        });



                        // Map balances to include decimals
                        let balancewithdecimals = balances.map((item, index) =>
                            ethers.utils.parseUnits(item.toString(), decimals[index]) // Adjust balance with decimals
                        );

                        // Send the transaction
                        tx = await daoRewardContract.addTokenReward(addresses, balancewithdecimals, { from: account });
                    }
                    else {
                        toast.error('something went wrong!!');
                        return;
                    }

                    toast.loading('Waiting for confirmation..');
                    var interval = setInterval(async function () {
                        let web3 = getWeb3();
                        var response = await web3.eth.getTransactionReceipt(tx.hash);
                        if (response != null) {
                            clearInterval(interval)
                            if (response.status === true) {
                                toast.dismiss();
                                toast.success('success ! your last transaction is success');
                            }
                            else if (response.status === false) {
                                toast.dismiss();
                                toast.error('error ! Your last transaction is failed.');
                            }
                            else {
                                toast.dismiss();
                                toast.error('error ! something went wrong.');
                            }
                        }
                    }, 5000);

                }
                else {
                    toast.error('Please connect mainnet chain!!');
                }
            }
            else {
                toast.error('Please connect wallet!!');
            }
        }
        catch (err) {
            toast.error(err.reason ? err.reason : err.message);
        }
    }

    const handleSubmit = async (id) => {
        try {
            if (account) {
                if (chain && chain.id && (DAO_SUPPOTED_CHAIN.includes(chain.id) || DEFAULT_CHAIN === chain.id)) {
                    let daoRewardContract = getContract(daorewardethAbi, DAO_REWARD[chain.id].DAO_REWARD_ADDRESS, library);
                    let tx;
                    if (id === 1) {
                        let a = ethDetails.totalSupply.split(',');
                        tx = await daoRewardContract.setTotalSupply(a, { 'from': account });
                    }
                    else if (id === 2) {
                        let a = ethDetails.weightPercentage.split(',');
                        a = a.map((items) => items * 100);
                        tx = await daoRewardContract.setWeightPercentage(a, { 'from': account });
                    }
                    else if (id === 3) {
                        // Split the input data into lines
                        const lines = ethDetails.daoreward.trim().split('\n');

                        // Initialize arrays for addresses, balances, and decimals
                        const addresses = [];
                        const balances = [];
                        const decimals = [];

                        // Process each line
                        lines.forEach(line => {
                            const [address, decimal, balance] = line.split(','); // Split each line by commas
                            addresses.push(address.trim());                      // Push address
                            balances.push(balance.trim());                       // Push balance as string
                            decimals.push(decimal ? parseInt(decimal.trim()) : 18); // Default decimal to 18 if undefined
                        });



                        // Map balances to include decimals
                        let balancewithdecimals = balances.map((item, index) =>
                            ethers.utils.parseUnits(item.toString(), decimals[index]) // Adjust balance with decimals
                        );

                        // Send the transaction
                        tx = await daoRewardContract.addTokenReward(addresses, balancewithdecimals, { from: account });
                    }
                    else if (id === 4) {
                        // Split the input data into lines
                        const lines = ethDetails.nftbalance.trim().split('\n');

                        // Initialize arrays for addresses, balances, and decimals
                        const addresses = [];
                        const balances = [];


                        // Process each line
                        lines.forEach(line => {
                            const [address, balance] = line.split(','); // Split each line by commas
                            addresses.push(address.trim());                      // Push address
                            balances.push(balance.trim());                       // Push balance as string
                        });

                        // Send the transaction
                        tx = await daoRewardContract.updateAddressNftBalance(ethDetails.nftid, addresses, balances, { from: account });
                    }
                    else {
                        toast.error('something went wrong!!');
                        return;
                    }

                    toast.loading('Waiting for confirmation..');
                    var interval = setInterval(async function () {
                        let web3 = getWeb3(DAO_REWARD[chain.id].RPC_URL);
                        var response = await web3.eth.getTransactionReceipt(tx.hash);
                        if (response != null) {
                            clearInterval(interval)
                            if (response.status === true) {
                                toast.dismiss();
                                toast.success('success ! your last transaction is success');
                            }
                            else if (response.status === false) {
                                toast.dismiss();
                                toast.error('error ! Your last transaction is failed.');
                            }
                            else {
                                toast.dismiss();
                                toast.error('error ! something went wrong.');
                            }
                        }
                    }, 5000);

                }
                else {
                    toast.error('Please connect mainnet chain!!');
                }
            }
            else {
                toast.error('Please connect wallet!!');
            }
        }
        catch (err) {
            toast.error(err.reason ? err.reason : err.message);
        }
    }

    const handleFetch = async () => {
        let nftBalanceData = await getWalletNFTDetails('', daoEthState.nftAddress[ethDetails.nftid], 500);
        let nftbal = {}; // Use an object for address-to-count mapping

        // Check if nftBalanceData exists and has valid data
        if (nftBalanceData && nftBalanceData.data && nftBalanceData.data.length > 0) {
            nftBalanceData.data.forEach((item) => {
                // Increment count if address already exists, otherwise initialize with 1
                if (nftbal[item.owner]) {
                    nftbal[item.owner] += 1;
                } else {
                    nftbal[item.owner] = 1;
                }
            });
        }

        // Convert the nftbal object into an array of { address, count }
        let userdata = Object.keys(nftbal).map((address) => `${address},${nftbal[address]}`).join('\n');

        setEthDetails({
            ...ethDetails,
            nftbalance: userdata
        })
    }

    const handleFetchTotalSupply = async () => {
        let calls = daoEthState.nftAddress.map((items) => {
            let nftContract = getNFTContract(items);
            return nftContract.methods.totalSupply();
        })

        let data = await MulticallContractWeb3(calls);

        setEthDetails({
            ...ethDetails,
            totalSupply: data.join(',')
        })

    }



    return (
        <>
            <div id="main-wrapper">
                <Header />
                <Sidebar />
                <div className="page-wrapper mt-4">
                    <div className='container-fluid'>
                        <div className="row">
                            <div className="col-12">
                                <div className="card">
                                    <div className="card-body">
                                        <div className="col-12">
                                            <div className="card">
                                                <div className="card-body">
                                                    <h4 className="card-title">Admin Setup</h4>
                                                    <div className="table-responsive ">
                                                        <table className="table table-dark table-bordered">
                                                            <thead>
                                                                <tr>
                                                                    <th>Name</th>
                                                                    <th>Value</th>
                                                                    <th>Action</th>

                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                <tr>
                                                                    <td>Disable Voting</td>
                                                                    <td>
                                                                        <input type="text" className="form-control" value={enableVote} onChange={(e) => setEnableVote(e.target.value)} placeholder="Disable or Enable Voting ex.true or false" />
                                                                    </td>
                                                                    <td>
                                                                        <button type="button" onClick={() => handleAdminSubmit(1)} className="btn btn-warning text-white">
                                                                            <span className="btn-text">Submit</span>
                                                                        </button>
                                                                    </td>

                                                                </tr>
                                                                <tr>
                                                                    <td>set Vote Weight</td>
                                                                    <td>
                                                                        {inputFields.map((data, index) => {
                                                                            const { service } = data;
                                                                            return (
                                                                                <>
                                                                                    <div className="input-group mb-3">
                                                                                        <input type="number" onChange={(evnt) => handleChange(index, evnt)} value={service} name="service" className="form-control mb-1" placeholder="Enter value Vote Weight.. ex.100" />
                                                                                        {(index === 0) ? (
                                                                                            <div className="input-group-append text-end">
                                                                                                <button className="btn btn-success text-white mx-1" type="button" onClick={(e) => addInputField(e)}>
                                                                                                    <i className="fa fa-plus"></i>
                                                                                                </button>
                                                                                            </div>
                                                                                        ) : (
                                                                                            <div className="input-group-append">
                                                                                                <button className="btn btn-success text-white mx-1" type="button" onClick={(e) => removeInputFields(index, e)}>
                                                                                                    <i className="fa fa-minus"></i>
                                                                                                </button>
                                                                                            </div>
                                                                                        )}
                                                                                    </div>
                                                                                </>
                                                                            )
                                                                        })}
                                                                    </td>
                                                                    <td>
                                                                        <button type="button" onClick={() => handleAdminSubmit(2)} className="btn btn-warning text-white">
                                                                            <span className="btn-text">Submit</span>
                                                                        </button>
                                                                    </td>

                                                                </tr>
                                                                <tr>
                                                                    <td>set NFT Address</td>
                                                                    <td>
                                                                        <input type="text" value={nftAddress} onChange={(e) => setNftAddress(e.target.value)} className="form-control" placeholder="Enter NFT Address" />
                                                                    </td>
                                                                    <td>
                                                                        <button type="button" onClick={() => handleAdminSubmit(5)} className="btn btn-warning text-white">
                                                                            <span className="btn-text">Submit</span>
                                                                        </button>
                                                                    </td>
                                                                </tr>
                                                                <tr>
                                                                    <td>Rescue NFT1155</td>
                                                                    <td>
                                                                        <input type="text" value={nfttokenAddress} onChange={(e) => setNfttokenAddress(e.target.value)} className="form-control" placeholder="token Address" />
                                                                        <input type="number" value={tokenId} onChange={(e) => setTokenId(e.target.value)} min="0" className="form-control mt-1" placeholder="token id" />
                                                                    </td>
                                                                    <td>
                                                                        <button type="button" onClick={() => handleAdminSubmit(6)} className="btn btn-warning text-white">
                                                                            <span className="btn-text">Submit</span>
                                                                        </button>
                                                                    </td>
                                                                </tr>
                                                                <tr>
                                                                    <td>Rescue Token</td>
                                                                    <td>
                                                                        <input type="text" value={tokenAddress} onChange={(e) => setTokenAddress(e.target.value)} className="form-control" placeholder="token Address" />
                                                                    </td>
                                                                    <td>
                                                                        <button type="button" onClick={() => handleAdminSubmit(7)} className="btn btn-warning text-white">
                                                                            <span className="btn-text">Submit</span>
                                                                        </button>
                                                                    </td>
                                                                </tr>
                                                                <tr>
                                                                    <td>Rescue Funds</td>
                                                                    <td>

                                                                    </td>
                                                                    <td>
                                                                        <button type="button" onClick={() => handleAdminSubmit(8)} className="btn btn-warning text-white">
                                                                            <span className="btn-text">Submit</span>
                                                                        </button>
                                                                    </td>
                                                                </tr>

                                                                <tr>
                                                                    <td>DAO Reward Add</td>
                                                                    <td>
                                                                        <textarea
                                                                            name="balance"
                                                                            rows={10}
                                                                            className='form-control'
                                                                            value={daoreward}
                                                                            placeholder={`enter token address, decimals and amount with command seprated
                                                                            0x3ADB732feD98f24c9E4f04037dbd405B009C68dF,18,100
                                                                            0x214cD5fF5ae0d734BEb0EdeA2Ed7d5199A7040eC,9,10000
                                                                        `}
                                                                            onChange={(e) => setDaoReward(e.target.value)}
                                                                        ></textarea>
                                                                    </td>
                                                                    <td>
                                                                        <button type="button" onClick={() => handleAdminSubmit(9)} className="btn btn-warning text-white">
                                                                            <span className="btn-text">Submit</span>
                                                                        </button>
                                                                    </td>
                                                                </tr>

                                                                <tr>
                                                                    <td colSpan={3} className='text-center'>ETH and BSC DAO Reward</td>
                                                                </tr>

                                                                <tr>
                                                                    <td>Total Supply<br />(1=Founder Node , 2= Master Node,<br /> 3= Legacy Node)</td>
                                                                    <td>
                                                                        <input type="text" name='totalSupply' value={ethDetails.totalSupply} onChange={(e) => handleEthChange(e)} className="form-control" placeholder="Enter command seprated values" />
                                                                    </td>
                                                                    <td>
                                                                        <button type="button" onClick={() => handleFetchTotalSupply()} className="btn btn-warning my-2 text-white">
                                                                            <span className="btn-text">Fetch Supply</span>
                                                                        </button><br />
                                                                        <button type="button" onClick={() => handleSubmit(1)} className="btn btn-warning text-white">
                                                                            <span className="btn-text">Submit</span>
                                                                        </button>
                                                                    </td>
                                                                </tr>

                                                                <tr>
                                                                    <td>Weight Percentage<br />(1=Founder Node , 2= Master Node,<br /> 3= Legacy Node)</td>
                                                                    <td>
                                                                        <input type="text" name='weightPercentage' value={ethDetails.weightPercentage} onChange={(e) => handleEthChange(e)} className="form-control" placeholder="Enter command seprated values" />
                                                                    </td>
                                                                    <td>
                                                                        <button type="button" onClick={() => handleSubmit(2)} className="btn btn-warning text-white">
                                                                            <span className="btn-text">Submit</span>
                                                                        </button>
                                                                    </td>
                                                                </tr>

                                                                <tr>
                                                                    <td>DAO Reward Add</td>
                                                                    <td>
                                                                        <textarea
                                                                            name="daoreward"
                                                                            rows={10}
                                                                            className='form-control'
                                                                            value={ethDetails.daoreward}
                                                                            placeholder={`enter token address, decimals and amount with command seprated
                                                                            0x3ADB732feD98f24c9E4f04037dbd405B009C68dF,18,100
                                                                            0x214cD5fF5ae0d734BEb0EdeA2Ed7d5199A7040eC,9,10000
                                                                        `}
                                                                            onChange={(e) => handleEthChange(e)}
                                                                        ></textarea>
                                                                    </td>
                                                                    <td>
                                                                        <button type="button" onClick={() => handleSubmit(3)} className="btn btn-warning text-white">
                                                                            <span className="btn-text">Submit</span>
                                                                        </button>
                                                                    </td>
                                                                </tr>

                                                                <tr>
                                                                    <td>Update Address with NFT Balance</td>
                                                                    <td>
                                                                        <select name='nftid' onChange={(e) => handleEthChange(e)} className='form-control my-2'>
                                                                            <option value={0} selected={ethDetails.nftid === 0}>Founder Node</option>
                                                                            <option value={1} selected={ethDetails.nftid === 1}>Master Node</option>
                                                                            <option value={2} selected={ethDetails.nftid === 2}>Legacy Node</option>
                                                                        </select>
                                                                        <textarea
                                                                            name="nftbalance"
                                                                            rows={10}
                                                                            className='form-control'
                                                                            value={ethDetails.nftbalance}
                                                                            placeholder={`enter token address and amount with command seprated
                                                                            0x3ADB732feD98f24c9E4f04037dbd405B009C68dF,100
                                                                            0x214cD5fF5ae0d734BEb0EdeA2Ed7d5199A7040eC,10000
                                                                        `}
                                                                            onChange={(e) => handleEthChange(e)}
                                                                        ></textarea>
                                                                    </td>
                                                                    <td>
                                                                        <button type="button" onClick={() => handleFetch()} className="btn btn-warning my-2 text-white">
                                                                            <span className="btn-text">Fetch Balance</span>
                                                                        </button><br />
                                                                        <button type="button" onClick={() => handleSubmit(4)} className="btn btn-warning text-white my-2">
                                                                            <span className="btn-text">Submit</span>
                                                                        </button>
                                                                    </td>
                                                                </tr>

                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <Footer />
            </div>
        </>
    )
}
